import {DomainEvent} from './DomainEvent';
import {Season} from '../resources/Season';

export class SeasonCreated extends DomainEvent<Season> {}
